<template>
  <div style="display: none;">
    <slot v-if="ready"></slot>
  </div>
</template>

<script>
import { LCircle } from 'vue2-leaflet'
import mixins from 'vue2-leaflet-editable/src/mixins'
export default {
  name: 'EditableCircle',
  extends: LCircle,
  mixins: [mixins]
}
</script>
